import { createEl, clearChildren } from '../dom.js';

/**
 * Одна секция refinement: заголовок facet-поля + checkbox-список значений
 * bucket'ов с бейджами-счётчиками. Multi-select: пользователь переключает checkbox'ы,
 * компонент вызывает onChange(field, value, checked) на каждое взаимодействие.
 *
 * Родитель (InlinePanel) поддерживает канонический Set `appliedFilters` и
 * заново вызывает `update(buckets, selected)` после каждого refetch — выбранные
 * значения приходят от родителя, чтобы server-side счётчики оставались авторитетными.
 */
export class RefinementList {
    /**
     * @param {Element} container
     * @param {{field: string, label: string, onChange: (field: string, value: string, checked: boolean) => void}} opts
     */
    constructor(container, { field, label, onChange }) {
        this.field = field;
        this.label = label;
        this.onChange = onChange;
        this.el = createEl('div', { className: 'doka-refinement', dataset: { field } });
        container.appendChild(this.el);
    }

    /**
     * @param {Array<{key: string|number, count: number}>} buckets
     * @param {Set<string>} selected  текущие выбранные значения (сравнение строк)
     */
    update(buckets, selected) {
        clearChildren(this.el);
        if (!buckets || buckets.length === 0) {
            this.el.hidden = true;
            return;
        }
        this.el.hidden = false;

        const title = createEl('div', { className: 'doka-refinement-title' }, [this.label]);
        this.el.appendChild(title);

        const list = createEl('ul', { className: 'doka-refinement-list', role: 'group', 'aria-label': this.label });
        for (const b of buckets) {
            const value = String(b.key);
            const checked = selected.has(value);
            const id = `doka-ref-${this.field}-${value.replace(/[^a-zA-Z0-9_-]/g, '_')}`;

            const cb = createEl('input', {
                type: 'checkbox',
                id,
                'aria-checked': checked ? 'true' : 'false',
                onChange: (e) => this.onChange(this.field, value, !!e.target.checked),
            });
            if (checked) cb.checked = true;

            const labelEl = createEl('label', { for: id, className: 'doka-refinement-row' }, [
                cb,
                createEl('span', { className: 'doka-refinement-value' }, [value]),
                createEl('span', { className: 'doka-refinement-count' }, [String(b.count)]),
            ]);

            const item = createEl('li', { className: 'doka-refinement-item' + (checked ? ' is-checked' : '') }, [labelEl]);
            list.appendChild(item);
        }
        this.el.appendChild(list);
    }
}
